import React from 'react'

import { Loader } from './index.styled'

const AnimatedCircle = ({ start = false }) => {
  return (
    <Loader className={[start ? 'start' : '', 'loader'].join(' ')}>
      <div className='left'>
        <span />
      </div>
      <div className='right'>
        <span />
      </div>
    </Loader>
  )
}

export default AnimatedCircle
